.dialog {
  outline: none;
}
